/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type HpRespLocationsModule_componentModule = {
    readonly title: string | null;
    readonly subtitle: string | null;
    readonly items: ReadonlyArray<{
        readonly cmsId: number | null;
        readonly linkData: {
            readonly path: string | null;
        };
        readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModuleItem_item">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModuleItemList_componentModule">;
    readonly " $refType": "HpRespLocationsModule_componentModule";
};
export type HpRespLocationsModule_componentModule$data = HpRespLocationsModule_componentModule;
export type HpRespLocationsModule_componentModule$key = {
    readonly " $data"?: HpRespLocationsModule_componentModule$data;
    readonly " $fragmentRefs": FragmentRefs<"HpRespLocationsModule_componentModule">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpRespLocationsModule_componentModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Product",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cmsId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "path",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpRespLocationsModuleItem_item"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "HpRespLocationsModuleItemList_componentModule"
    }
  ],
  "type": "LocationsModule",
  "abstractKey": null
};
(node as any).hash = 'eb02db3e068bf0ffb353678e5649d0c0';
export default node;
